import React from 'react';
import { Users, Wrench, UtensilsCrossed, MessageSquare } from 'lucide-react';
export function WhyAttend() {
  const reasons = [{
    icon: <Users className="text-[#FFF8DC]" size={28} data-id="element-266" />,
    title: 'Network with Leaders',
    description: 'Connect with 50 ecommerce finance leaders and CFOs facing similar growth challenges.'
  }, {
    icon: <Wrench className="text-[#FFF8DC]" size={28} data-id="element-267" />,
    title: 'Hands-on Tools',
    description: 'Deep dive into the latest financial tech stacks with practical demos and workshops.'
  }, {
    icon: <UtensilsCrossed className="text-[#FFF8DC]" size={28} data-id="element-268" />,
    title: 'Franklin BBQ Dinner',
    description: 'Private restaurant takeover. No line required for the world-famous brisket.'
  }, {
    icon: <MessageSquare className="text-[#FFF8DC]" size={28} data-id="element-269" />,
    title: 'Fireside Chat',
    description: 'Potential discussion with Aaron & Stacy Franklin on scaling a legendary business.'
  }];
  return <section id="why-attend" className="py-24 bg-[#8B4513] text-white relative overflow-hidden" data-id="element-270">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'url("https://www.transparenttextures.com/patterns/wood-pattern.png")'
    }} data-id="element-271"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-272">
        <div className="text-center mb-16" data-id="element-273">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6" style={{
          fontFamily: 'Rockwell, "Courier New", serif'
        }} data-id="element-274">
            Why Attend?
          </h2>
          <div className="w-24 h-1 bg-[#F4A460] mx-auto" data-id="element-275"></div>
          <p className="mt-8 text-xl text-[#F4A460] max-w-2xl mx-auto" data-id="element-276">
            More than just a conference. It's a community gathering with
            purpose.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-277">
          {reasons.map((reason, index) => <div key={index} className="bg-[#2F1B10] bg-opacity-50 p-8 rounded-lg border border-[#D2691E] hover:bg-opacity-70 transition-colors group" data-id="element-278">
              <div className="mb-6 bg-[#D2691E] w-14 h-14 rounded-lg flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-279">
                {reason.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#F4A460] font-serif" data-id="element-280">
                {reason.title}
              </h3>
              <p className="text-[#FFF8DC] opacity-90 leading-relaxed" data-id="element-281">
                {reason.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}